import {connect} from 'react-redux';
import {IStore} from '../../../redux/session/reducers';
import {SessionQuestionPopover as Container, ISessionQuestionPopoverProps} from './question-popover-ui';
import {selfStatusSelector} from '../../../redux/session/selectors';

const mapStateToProps = (state: IStore): ISessionQuestionPopoverProps => ({
  isInterviewer: state.session.isInterviewer,
  hadQuestionChanged: state.session.hadQuestionChanged,
  isQuestionNew: state.session.isQuestionNew,
  selfStatus: selfStatusSelector(state),
});

const mapDispatchToProps = {};

export const SessionQuestionPopover = connect<ISessionQuestionPopoverProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(Container);
